import {
  doc,
  getDocs,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "firebase/firestore";

import { ContactSubmissionsRef, db } from "../../../../firebase";

/**
 * Data access for contact form submissions (`contactSubmissions`).
 * Written by the submitContactForm cloud function; managed here by admins.
 */

// Normalize a Firestore Timestamp / Date / string to milliseconds.
export const submissionMillis = (ts) => {
  if (!ts) return 0;
  if (typeof ts.toMillis === "function") return ts.toMillis();
  if (ts instanceof Date) return ts.getTime();
  if (ts.seconds != null) return ts.seconds * 1000;
  const parsed = Date.parse(ts);
  return Number.isNaN(parsed) ? 0 : parsed;
};

// Fetch all submissions, newest first.
export const getContactSubmissions = async () => {
  try {
    const snapshot = await getDocs(ContactSubmissionsRef);
    const items = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
    items.sort(
      (a, b) => submissionMillis(b.createdAt) - submissionMillis(a.createdAt)
    );
    return items;
  } catch (error) {
    console.log("Error fetching contact submissions:", error.message);
    return [];
  }
};

export const updateSubmissionStatus = async (id, status) => {
  return await updateDoc(doc(db, "contactSubmissions", id), {
    status,
    updatedAt: serverTimestamp(),
  });
};

export const bulkUpdateSubmissionStatus = async (ids, status) => {
  const batch = writeBatch(db);
  ids.forEach((id) => {
    batch.update(doc(db, "contactSubmissions", id), {
      status,
      updatedAt: serverTimestamp(),
    });
  });
  return await batch.commit();
};
